import script from "./ProductNeue.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductNeue.vue?vue&type=script&setup=true&lang=js"

import "./ProductNeue.vue?vue&type=style&index=0&id=73fb2e52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fb2e52"]])

export default __exports__

/* vue-cli-plugin-import-components */

import CpspModal from "@/components/neue/CPSPModal.vue";
import EmptyState from "@/components/neue/EmptyState.vue";
import FormElement from "@/components/neue/FormElement.vue";
import FormSection from "@/components/neue/FormSection.vue";
import FranchiseLockNotice from "@/components/franchise/FranchiseLockNotice.vue";
import ImageUploaderNeue from "@/components/neue/ImageUploaderNeue.vue";
import InlineSearchSelect from "@/components/InlineSearchSelect.vue";
import InputArea from "@/components/neue/InputArea.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueCheckbox from "@/components/neue/NeueCheckbox.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueTablist from "@/components/neue/NeueTablist.vue";
import NeueToggle from "@/components/neue/NeueToggle.vue";
import PageFooter from "@/components/PageFooter.vue";
import ParsleyLockNotice from "@/components/parsley/ParsleyLockNotice.vue";
import SaveBar from "@/components/SaveBar.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import SegmentedControl from "@/components/neue/SegmentedControl.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
import TablistGrid from "@/components/neue/TablistGrid.vue";
import TablistHeader from "@/components/neue/TablistHeader.vue";
import TablistRow from "@/components/neue/TablistRow.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { CpspModal, EmptyState, FormElement, FormSection, FranchiseLockNotice, ImageUploaderNeue, InlineSearchSelect, InputArea, InputField, NeueButton, NeueCheckbox, NeueLoading, NeueTablist, NeueToggle, PageFooter, ParsleyLockNotice, SaveBar, SecondaryNav, SecondaryTop, SegmentedControl, SelectInput, SettingsSection, TablistGrid, TablistHeader, TablistRow, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { CpspModal, EmptyState, FormElement, FormSection, FranchiseLockNotice, ImageUploaderNeue, InlineSearchSelect, InputArea, InputField, NeueButton, NeueCheckbox, NeueLoading, NeueTablist, NeueToggle, PageFooter, ParsleyLockNotice, SaveBar, SecondaryNav, SecondaryTop, SegmentedControl, SelectInput, SettingsSection, TablistGrid, TablistHeader, TablistRow, TheModal }, script.__o.components);}